import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { ClusterInvoiceDto } from 'src/api/v2';
import { formatDateInputDate } from 'src/utils/FormatValue';
import { Link } from 'react-router-dom';
import { ROUTES } from 'src/navigation';

const columnHelper = createColumnHelper<ClusterInvoiceDto>();

export const useClusterInvoicesColumns = () => {
  return [
    columnHelper.accessor((row) => row.clusterMemberName, {
      id: 'clusterMemberName',
      cell: ({
        getValue,
        row: {
          original: { clusterMemberId, invoiceDate },
        },
      }) => {
        const year = new Date(invoiceDate).getFullYear().toString();
        return (
          <Link to={ROUTES.RESOURCE_BASE.MEMBERS.DETAILS(clusterMemberId || '').INVOICES(year)}>
            {getValue()}
          </Link>
        );
      },
      minSize: 200,
    }),
    columnHelper.accessor('clusterMemberOrgNo', { id: 'clusterMemberOrgNo' }),
    columnHelper.accessor((row) => formatDateInputDate(row.invoiceDate), {
      id: 'invoiceDate',
      sortingFn: 'datetime',
    }),
    columnHelper.accessor('marketValue', { id: 'marketValue' }),
    columnHelper.accessor('deductible', { id: 'deductible' }),
    columnHelper.accessor('description', { id: 'description' }),
  ];
};
